import axios from "axios";

const checkCouponCode = async (couponCode) => {
  try {
    const response = await axios.get(
      `${process.env.SERVER_BASE_URL}/durga-puja-2025/coupon/check/${couponCode}`
    );
    return response.data;
  } catch (error) {
    console.error("Error validating coupon code:", error);
    return null;
  }
};

export default checkCouponCode;
